import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Text, useTheme } from '@Sage/hoi-poi-ui';

import ModalHoi from 'components/ModalHoi';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';

import './styles.scss';

const CampaignSendConfirmModal = memo(
    ({
        isConsentChecked,
        isOpen,
        isSubmitting,
        onConsentChange,
        onConfirm,
        onRequestClose,
        recipientsCount,
    }) => {
        const theme = useTheme();
        const formattedRecipientsCount = Number(recipientsCount || 0).toLocaleString();

        return (
            <ModalHoi
                className="campaign-send-confirm-modal"
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                onCancel={onRequestClose}
                onConfirm={onConfirm}
                title={getLiteral('title_marketing_campaigns_send_email_campaign_confirm')}
                cancelText={getLiteral('action_cancel')}
                confirmText={getLiteral('action_send_email_now')}
                isLoading={isSubmitting}
                size="medium"
                useHeader
                useCornerClose
                isConfirmDisabled={isSubmitting || !isConsentChecked}
                buttonsLowercase
            >
                <Text className="campaign-send-confirm-modal__message" type="body">
                    {getLiteralWithParameters(
                        'label_marketing_campaigns_send_email_campaign_confirm_message',
                        [formattedRecipientsCount],
                    )}
                </Text>
                <div className="campaign-send-confirm-modal__consent">
                    <Checkbox
                        checked={isConsentChecked}
                        color="actionMinor"
                        size="medium"
                        onChange={onConsentChange}
                    />
                    <Text type="body" color={theme.colors.utility.textSecondary}>
                        {getLiteral('label_marketing_campaigns_send_confirm_consent')}
                    </Text>
                </div>
            </ModalHoi>
        );
    },
);

CampaignSendConfirmModal.propTypes = {
    isConsentChecked: PropTypes.bool,
    isOpen: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    onConsentChange: PropTypes.func,
    onConfirm: PropTypes.func,
    onRequestClose: PropTypes.func,
    recipientsCount: PropTypes.number,
};

CampaignSendConfirmModal.displayName = 'CampaignSendConfirmModal';

export default CampaignSendConfirmModal;
